import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { ChangeRequest } from '@app/core/model/change-request.model'
import { ApplicationSetting } from '@app/core/model/enums/application-setting.enum'
import { ScopeVersion, StatusType } from '@app/core/model/scope-version'
import { AuthService } from '@app/core/service/auth.service'
import { ApprovalFlowService } from '@app/features/scope-overview/service/approval-flow.service'
import { ScopeOverviewActions } from '@app/features/scope-overview/store/actions/scope-overview.action'
import { ScopeUiInputComponent } from '@app/shared/components/ui-components/scope-ui-input/scope-ui-input.component'
import { SharedModule } from '@app/shared/shared.module'
import { Store } from '@ngrx/store'
import { plainToInstance } from 'class-transformer'
import { ScopeStatusColor } from './const/scope-status-color.enum'

@Component({
  selector: 'scope-overview-header',
  standalone: true,
  imports: [CommonModule, SharedModule, ScopeUiInputComponent],
  templateUrl: './scope-overview-header.component.html',
  styleUrls: ['./scope-overview-header.component.scss'],
})
export class ScopeOverviewHeaderComponent {
  @Input() scope: ScopeVersion
  @Input() changeRequest?: ChangeRequest

  editName = false

  get hasChangeRequestsFeature(): boolean {
    return (
      (this.hasApplicationSetting(ApplicationSetting.CHANGE_REQUEST) ?? false) &&
      (this.hasApplicationSetting(ApplicationSetting.SCOPE__ENABLE_CHANGE_REQUEST) ?? false)
    )
  }

  constructor(
    private store$: Store,
    private router: Router,
    private authService: AuthService,
    protected approvalFlowService: ApprovalFlowService
  ) {}

  hasApplicationSetting(setting: ApplicationSetting): boolean {
    return this.authService.loggedInUser?.company.hasApplicationSetting(setting) ?? false
  }

  redirectToSow(sowId: number) {
    this.router.navigateByUrl('/scopes/folder-overview/' + sowId)
  }

  updateScopeName(name: string, scope: ScopeVersion) {
    this.editName = false
    const updatedScope = plainToInstance(ScopeVersion, { ...scope, name })
    this.store$.dispatch(ScopeOverviewActions.updateScope({ scope: updatedScope }))
  }

  getCellClass(status: StatusType): string {
    const defaultCellClass = ''

    if (this.changeRequest && this.hasChangeRequestsFeature) return 'text-orange-500'

    return status?.length ? ScopeStatusColor[status] || defaultCellClass : defaultCellClass
  }

  protected ApplicationSetting = ApplicationSetting
}
